<template>
  <div class="search-design-item">
    <div class="search-item-box">
      <div class="search-item-label">
        <label style="text-align: right" :title="dModel.label">{{ dModel.label }}</label>
      </div>
      <div class="search-item-control">
        <el-input placeholder="" v-model="dValule" clearable v-if="searchShowConfig['input'].indexOf(dModel.type)!=-1"
          @change="currentSel"></el-input>
        <DesignSelect v-model="dValule" :options="dModel.options"
          v-if="searchShowConfig['select'].indexOf(dModel.type)!=-1" @input="changeValue()">
        </DesignSelect>

        <el-date-picker v-model="dValule" type="daterange" range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期" v-if="searchShowConfig['date'].indexOf(dModel.type)!=-1" value-format="yyyy-MM-dd">
        </el-date-picker>

      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'DesignSearchItem',
    data() {
      return {
        searchModel: {},
        dValule: "",
        //搜索区域显示，根据类型进行不同而显示
        // "input", "textarea", "number" 显示普通文本
        // "select", "checkbox", "radio" 显示下拉
        // "date", "datePicker"  显示日期
        searchShowConfig: {
          "input": ["input", "textarea", "number"],
          "select": ["select", "checkbox", "radio"],
          "date": ["date", "datePicker"]
        }
      }

    },
    watch: {
      dValule: function() {
        this.$emit("input", this.dValule)
      }
    },
    props: {
      dModel: {
        type: Object,
        default: function() {
          return {
            key: "",
            label: "",
            model: "",
            type: "",
          }
        }
      },
      options: {
        type: Object,
        default: () => {}
      },
    },
    components: {

    },
    methods: {
      currentSel: function() {
        // this.$emit("input", selVal);
      },
      changeValue: function() {

      },
    },
    mounted() {
      let that = this
      that.searchModel = that.$utils.clone(that.dModel)
    }
  }
</script>
<style scoped>
  .search-design-item {
    float: left;
  }
  /deep/.el-range-editor .el-range-input{
    font-size: 13px;
  }
/*  .search-item-box{
    width: 360px;
  }
  
  .search-item-box .search-item-control {
    width: 260px;
  } */
</style>
